let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4ko5y")).then(() => parcelRequire('5loX9'));